import React, { useState } from 'react'
import './styles/ticTacToe.css';

const Tile = ({ value, index, player, onClick, isWinningSquare, disabled, characterOne, characterTwo }) => {

    // const [tiles, setTiles] = useState(false);

    // const player = value === "playerX" ? "X" : "O";

    const playButtonSound = () => {
        const audio = new Audio('/sounds/player-move.mp3');
        audio.play();
    }

    const handleClick = () => {
        if (disabled) {
            return
        }
        playButtonSound();
        onClick();
    }

    return (
        <div onClick={handleClick} className='square'>

            {value === 'X' ? (
                <img className={`tic-tac-toe-character animate__animated animate__pulse svg-size animate-delay ${isWinningSquare ? 'winning-square' : 'o'}`} src={`${process.env.PUBLIC_URL}${characterOne}`} />


            ) : value === 'O' ? (

                <img className={`tic-tac-toe-character animate__animated animate__pulse svg-size animate-delay ${isWinningSquare ? 'winning-square' : 'o'}`} src={`${process.env.PUBLIC_URL}${characterTwo}`} />


            ) : (
                <p></p>
            )}
        </div>
    )
}

export default Tile